/** @jsx jsx */

import { css, jsx } from "@emotion/react";
import bgLeft from "../../../images/noissue-tv-left.svg";
import bgRight from "../../../images/noissue-tv-right.svg";
import { withPrefix } from "gatsby-link";
import TVBlock from "./TVBlock";

const WrapNoissueTV = ({ data }) => {
    const finalData = data.filter(video => video.channel.slug==="how-to-pack").slice(0, 10);
    return (
            <section
                css={css`
                    width: 100%;
                    position: relative;
                    background: url(${bgLeft}) bottom 22rem left / 25%,
                        url(${bgRight}) top 1rem right / 25%,
                        linear-gradient(180deg, #FAD6C3 82.67%, #FFDCF9 100%);
                    background-repeat: no-repeat;
                    text-align: center;
                    min-height: 90rem;
                    padding-top: 6rem; 
                `}
            >
                <div>
                <h1 css={css`
                    color: #2748F3;
                    font-size: 8rem;
                    text-align: center;
                    line-height: 10rem;
                    @media(max-width: 1024px){
                        font-size: 5rem;
                        line-height: 5rem;
                    }
                `}>
                    noissueTV
                </h1>
                <p css={css`
                    margin: auto;
                    max-width: 60rem;
                    color: #616161;
                    font-size: 1.5rem;
                    line-height: 2.4rem;
                    @media(max-width: 1024px){
                        max-width: 40rem;
                    }
                `}>Here you'll find all our watchable content, including profiling businesses, brands, and makers on a question of the month, chatting through ecommerce topics beyond packaging, and talking to changemakers and leaders practicing sustainable business. You'll find inspiration everywhere you look!</p>

                <TVBlock videos={finalData}/>

                <a
                    css={css`
                        font-size: 1.6rem;
                        font-weight: 400;
                        line-height: 1.6;
                        padding: 1rem 4rem;
                        color: #2748F3;
                        border-radius: 1rem;
                        border: 0.2rem solid #2748F3;
                        cursor: pointer;
                        display: inline-block;
                        margin: 2rem auto;
                    `}
                    href={withPrefix("/noissuetv/")}
                >
                    See More
                </a>
                </div>

            </section>
    );
};

export default WrapNoissueTV;
